import React, { createContext, ReactNode, useMemo, useState } from 'react';

type PayWallContextType = {
  showCreditCardForm: boolean;
  showAddressForm: boolean;
};

type PayWallDispatchContextType = {
  setShowCreditCardForm: React.Dispatch<React.SetStateAction<boolean>>;
  setShowAddressForm: React.Dispatch<React.SetStateAction<boolean>>;
};

export const PayWallContext = createContext<PayWallContextType>({
  showCreditCardForm: false,
  showAddressForm: false,
});

export const PayWallDispatchContext = createContext<PayWallDispatchContextType>({
  setShowCreditCardForm: () => null,
  setShowAddressForm: () => null,
});

const PayWallContextProvider = ({ children }: { children: ReactNode }) => {
  const [showCreditCardForm, setShowCreditCardForm] = useState(false);
  const [showAddressForm, setShowAddressForm] = useState(false);

  const payWallContextValue = useMemo(
    () => ({
      showCreditCardForm,
      showAddressForm,
    }),
    [showCreditCardForm, showAddressForm]
  );

  const payWallContextDispatchValue = useMemo(
    () => ({
      setShowCreditCardForm,
      setShowAddressForm,
    }),
    [setShowCreditCardForm, setShowAddressForm]
  );

  return (
    <PayWallContext.Provider value={payWallContextValue}>
      <PayWallDispatchContext.Provider value={payWallContextDispatchValue}>{children}</PayWallDispatchContext.Provider>
    </PayWallContext.Provider>
  );
};

export default PayWallContextProvider;
